import { Arrow } from "./Svgs";
import './PriorityModal.scss';
import { useState, useEffect } from "react";

const PriorityModal = ({ side, currentPriority, rowMenuOpen, setRowMenuOpen, setActionFileId, setTypeOfAction }) => {
    const [modalOpen, setModalOpen] = useState(false)
    const [newPriority, setNewPriority] = useState(null)
    const [modalPosition, setModalPosition] = useState<{ left: number; bottom: number; side: 'down' | 'up' } | null>(null);
    const priorities = ['Default', 'Immediate', 'High', 'Low']

    // Priority mapping constant
    const PRIORITY_MAP: Record<string, string> = {
        Low: "FILE_DL_PRIORITY_LOW",
        Default: "FILE_DL_PRIORITY_NORMAL",
        High: "FILE_DL_PRIORITY_HIGH",
        Immediate: "FILE_DL_PRIORITY_IMMEDIATE",
    };

    //HANDLE PRIORITY DROPDOWN OPEN
    const handleDropdownOpen = (e: React.MouseEvent) => {
        e.stopPropagation();
        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
        const menuHeight = 150; // estimated height of your dropdown
        const viewportHeight = window.innerHeight;
        const offset = side === 'down'
            ? { left: 0, bottom: -147.5 }
            : { left: 130, bottom: -100.5 };


        //if going below the screen
        const adjustedOffset = (viewportHeight - rect.bottom < menuHeight)
            ? {
                ...offset,
                bottom: side === 'down' ? 40 : 0,
            }
            : offset;
        setModalPosition({ ...adjustedOffset, side });
        setModalOpen((prev) => !prev); // toggle open/close
    };

    //HANDLE SELECT NEW PRIORITY
    const handlePrioritySet = (p) => {
        setNewPriority(p)
    }

    //HANDLE CANCEL SELECTED PRIORITY
    const handleCancel = () => {
        setModalOpen(false)
        setNewPriority(currentPriority)
    }

    const handleApply = () => {
        // Map UI priority to backend priority using the constant
        const backendPriority = PRIORITY_MAP[newPriority ?? 'Default'] ?? PRIORITY_MAP.Default;

        setActionFileId({ status: backendPriority, fileId: rowMenuOpen?.uniqueId });
        setTypeOfAction('cancel');
        setModalOpen(false);
        setRowMenuOpen(null);
    };

    //SET THE CURRENT PRIORITY
    useEffect(() => {
        setNewPriority(currentPriority)
    }, [currentPriority])

    return (
        <div className='priority__modal__container'>
            <div className='priority_modal_selector' style={{ borderRadius: '4px' }}>
                <div className='priority_modal_selector_body' onClick={(e) => handleDropdownOpen(e)}>
                    <span className='ms-2'>Change Priority</span>
                    <Arrow direction={side} />
                </div>
            </div>
            {modalOpen &&
                <div className='priority_modal_dropdown'
                    style={{
                        left: `${modalPosition?.left}px`,
                        bottom: `${modalPosition?.bottom}px`,
                    }}
                >
                    <div className='priority_modal_dropdown_body'>
                        {priorities?.map((p, index) => (
                            <div className='priority_modal_dropdown_row' key={index}>
                                <span role='button' className={`priority_modal_dropdown_row_text ${p === newPriority ? 'active' : ''}`} onClick={() => handlePrioritySet(p)}>
                                    {p}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div className='priority_modal_bottom_bar'>
                        <button className='priority-cancel' onClick={handleCancel}>Cancel</button>
                        <button className='priority-apply' onClick={handleApply}>Apply</button>
                    </div>
                </div>
            }
        </div>

    )
}

export default PriorityModal;